import { AxiosError, AxiosRequestConfig } from 'axios'
import { useClient } from './context'


export type ErrorInterceptor = (_: AxiosError<any>) => never | void
export type RequestInterceptor = (_: AxiosRequestConfig) => void


export const useInterceptor = () => {

    const state = useClient()
  
  
    const self = {
  
      addOnError: (interceptor: ErrorInterceptor) => {
  
        state.setQuietly(s => s.onError.unshift(interceptor))
      }
  
      ,
  
      addOnRequest: (interceptor: RequestInterceptor) => {
  
        state.setQuietly(s => s.onRequest.unshift(interceptor))
      }
  
      ,
  
    }
  
    return self
  
  }